// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__3Cy1n","submitButton":"LoginForm_submitButton__3-7-B","cancelButton":"LoginForm_cancelButton__ZBR5W","centered":"LoginForm_centered__1nKIR"};